import { createFileRoute } from '@tanstack/react-router'

import { GeocodesPage } from '#/modules/catalog/geocodes-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/geocodes')({
  component: GeocodesPage,
  validateSearch: validateListSearch,
})
